import * as OTPAuth from "otpauth";

export const generateOtpHeader = (apiKey: string) => {
  const totpSecret = OTPAuth.Secret.fromUTF8(apiKey);
  const totp = new OTPAuth.TOTP({
    issuer: "Locker",
    label: "OTPSecretAccess",
    algorithm: "SHA1",
    digits: 10,
    period: 30,
    secret: totpSecret,
  });
  return totp.generate();
};
